import { TaskDefinition, Dependancy } from 'src/stores/workflowDefinitionCanvasStore/workflowDefinitionCanvasStore.interface';
import { WorkflowCreationMetaData } from 'src/stores/workflowCreationMetaDataStore/workflowCreationMetaDataStore.interface';

export const SCHEMA_VERSION = '1.0.0';

export type ExportFormat = 'json' | 'yaml';

export interface ExportableWorkflowDefinition {
  schemaVersion: string;
  exportedAt: string;
  workflowDefinition: WorkflowCreationMetaData;
  taskDefinitions: TaskDefinition[];
  dependencies: Dependancy[];
}

export interface ExportOptions {
  format: ExportFormat;
}

export interface ExportResult {
  success: boolean;
  filename: string;
  error?: string;
}
